// router.js
import { createBrowserRouter } from 'react-router-dom';
import AppLayout from './App';
import AddTunePage from './pages/AddTunePage';
import SearchPage from './pages/SearchPage';
import SettingsPage from './pages/SettingsPage';
import TuneDetailPage from './pages/TuneDetailPage';
import SessionViewer from './pages/SessionViewer';
// import EditTunePage from './pages/EditTunePage'; // kept for future re-enable
import SetsPage from './pages/SetsPage';
import EditSetPage from './pages/EditSetPage';
import SetDetailPage from './pages/SetDetailPage';
import EditProgramPage from './pages/EditProgramPage';
import FillProgramPage from './pages/FillProgramPage';
import EditSessionPage from './pages/EditSessionPage';
import { Navigate } from 'react-router-dom';
import StatsPage from './pages/StatsPage';
import SocialPage from './pages/SocialPage';
import ProfilePage from './pages/ProfilePage';
import UserPage from './pages/UserPage';
import PublicTuneDetailPage from './pages/PublicTuneDetailPage';
import HelpPage from './pages/HelpPage';


const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
children: [
  { path: '', element: <Navigate to='/search' replace /> },   // 👈 REQUIRED
  { path: 'add', element: <AddTunePage /> },
  { path: 'mytunes', element: <SearchPage /> },
  { path: 'search', element: <SearchPage /> },
  { path: 'sessions', element: <SessionViewer /> },
  
  { path: 'editsession/:sessionId', element: <EditSessionPage /> },
  { path: 'settings', element: <SettingsPage /> },
  { path: 'help', element: <HelpPage /> },
  { path: 'stats', element: <StatsPage /> },

  { path: 'tune/:id', element: <TuneDetailPage /> },
  // { path: 'edit/:id', element: <EditTunePage /> }, // temporarily disabled
  // { path: 'tune/:id/edit', element: <EditTunePage /> }, // temporarily disabled
  { path: 'sets', element: <SetsPage /> },
  { path: 'sets/:id', element: <SetDetailPage /> },
  { path: 'sets/:id/edit', element: <EditSetPage /> },
  { path: 'sets/:id/edit-program', element: <EditProgramPage /> },
  { path: 'sets/:id/fill', element: <FillProgramPage /> },
  { path: 'social', element: <SocialPage /> },
  { path: 'social/profile', element: <ProfilePage /> },
  { path: 'user/:uid', element: <UserPage /> },
  { path: 'user/:uid/tune/:tuneId', element: <PublicTuneDetailPage /> },
  { path: '*', element: <Navigate to='/search' replace /> },
]
,
  },
]);

export default router;
